import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import { Toggle } from '@/components/elements/toggle'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/elements/tooltip'
import { cn } from '@/utils/helpers'

export const ToolbarButton = forwardRef(
  ({ isActive, children, tooltip, className, tooltipOptions, ...props }, ref) => {
    const toggleButton = (
      <Toggle
        size="sm"
        ref={ref}
        className={cn('size-8 p-0', { 'bg-accent': isActive }, className)}
        {...props}
      >
        {children}
      </Toggle>
    )

    if (!tooltip) {
      return toggleButton
    }

    return (
      <Tooltip>
        <TooltipTrigger asChild>{toggleButton}</TooltipTrigger>
        <TooltipContent {...tooltipOptions}>
          <div className="flex flex-col items-center text-center">{tooltip}</div>
        </TooltipContent>
      </Tooltip>
    )
  },
)

ToolbarButton.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  tooltipOptions: PropTypes.object,
}

ToolbarButton.displayName = 'ToolbarButton'

export default ToolbarButton
